
import React, { useState, useEffect } from 'react';
import { 
  Close
} from '@mui/icons-material';
import { Fab } from '@mui/material';

import Grid from '@mui/material/Grid2';

import CommonUtilities from "@utilities/common_utilities";

interface Props {
  children: React.ReactNode;
  openTime: number;
}

const common_util = CommonUtilities.getInstance();

export default function ToastBox({ 
  children,
  openTime,
}: Props) {
  const [is_open, setOpen] = useState(false);
  const [open_time, setOpenTime] = useState(-1);
  const [ping, setPing] = useState(-1);

  useEffect(() => {
    if (openTime !== open_time) {
      // debugger;
      setOpenTime(openTime);
      setOpen(true);
      setTimeout(() => {
        setPing(common_util.get_time_number());
      }, 5000);
    }
  }, [openTime, open_time, ping, setOpenTime, setOpen, setPing]);

  useEffect(() => {
    if (is_open) {
      const time_number = common_util.get_time_number();
      if (open_time + 4 <= time_number) {
        setOpen(false);
      }
    }
  }, [is_open, open_time, setOpen, ping]);

  if (is_open) {
    return (
      <div style={{ 
        position: "fixed",
        zIndex: 999,
        right: 20,
        bottom: 60
      }}>
        <Grid container spacing={0} direction="row" className="bg_black bordered">
          <Grid
            size={{
              xs: 12
            }}>
            { children }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <div style={{ float: "right" }}>
              <Fab size="small" color="primary"
                onClick={() => {
                  setOpen(false);
                }}>
                <Close />
              </Fab>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
  return <></>;
}
